import { render, staticRenderFns } from "./Formulario012BNormal.vue?vue&type=template&id=7e737840"
import script from "./Formulario012BNormal.vue?vue&type=script&lang=js"
export * from "./Formulario012BNormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports